import HeaderContainers from '../HeaderContainers/HeaderContainers';
import InputPadrao from '../InputPadrao/InputPadrao';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import InputSelectPadrao from '../InputSelectPadrao/InputSelectPadrao';
import './FormCadastroDepartamento.css'
import { MdBadge } from "react-icons/md";
import { DepartamentoContext } from '../../context/DepartamentoContext';
import { useContext, useEffect, useState } from 'react';
import { RiErrorWarningFill } from "react-icons/ri";
import { getSituacaoCadastro } from '../../services/situacaoCadastroService';
import { SiGlassdoor } from "react-icons/si";
import NotifyUtils from '../../utils/NotifyUtils';
import { useAuth } from '../../services/AuthContext';
import Loading from '../Loading/Loading';
import { useTranslation } from 'react-i18next';

function FormCadastroDepartamento() {

    const [ loading, setLoading ] = useState(true);
    const { t }  = useTranslation();
    const { user, setPodeCadastrarUsuario } = useAuth();
    const { handleChange, handleSubmit, handleCancelling } = useContext(DepartamentoContext);

    if(!user.podeCadastrarDepartamento) {
        window.location.href = '/departamentos';
    }

    const textoCarregando = t("texto-carregando");
    const textoConfirmar = t("botao-confirmar");
    const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
    const [mensagemBotaoConfirmar, setMensagemBotaoConfirmar] = useState(textoConfirmar);

    const [ nomeDepartamentoValido, setNomeDepartamentoValido ] = useState(true);
    const [ siglaValida, setSiglaValida ] = useState(true);
    const [ situacaoCadastroValida, setSituacaoCadastroValida ] = useState(true);

    const [situacaoCadastro, setSituacaoCadastro] = useState(null);
    useEffect(() => {
        async function fetchSituacao() {
            const situacaoCadastroFetched = await getSituacaoCadastro();
            setSituacaoCadastro(situacaoCadastroFetched);
            setLoading(false);
        }

        fetchSituacao();
    }, []);
    
    const handleCancelar = () => {
        handleCancelling();
    }

    let situacoesCadastro = [];
    if (situacaoCadastro !== null) {
        situacoesCadastro = situacaoCadastro;
    }

    const clickBotaoConfirmar = async (e) => {
        // Assim que confirmar, desabilita o botão e muda o texto para "carregando..."
        e.preventDefault();
        setBotaoDesabilitado(true);
        setMensagemBotaoConfirmar(textoCarregando);

        // Faz o envio de informações para o back caso esteja tudo certo com os campos, se não tiver, retorna os campos inválidos
        const retornoRequest = await handleSubmit();
        const erroCustom = retornoRequest.success === undefined;

        if(retornoRequest === null) {
            NotifyUtils.info(t("cadastrando"));
            return;
        }

        if(!retornoRequest.success && !erroCustom) {
            NotifyUtils.erro(retornoRequest.message);
        } else if(retornoRequest.success) {
            NotifyUtils.sucesso(retornoRequest.message);
            NotifyUtils.sucesso(t("texto-redirecionando"));

            setNomeDepartamentoValido(true);
            setSiglaValida(true);
            setSituacaoCadastroValida(true);

            setTimeout(() => {
                handleCancelling();
                setBotaoDesabilitado(false);
                setMensagemBotaoConfirmar(textoConfirmar);
            }, 3500);

            setPodeCadastrarUsuario(true);
            return;
        } else if(erroCustom) {
            NotifyUtils.erro(retornoRequest.message);

            // Atualiza status dos campos inválisdos
            const camposInvalidos = retornoRequest.camposInvalidos;

            setNomeDepartamentoValido(camposInvalidos.nomeValido);
            setSiglaValida(camposInvalidos.siglaValida);
            setSituacaoCadastroValida(camposInvalidos.situacaoValida);
        }

        setBotaoDesabilitado(false);
        setMensagemBotaoConfirmar(textoConfirmar);
    }

    return (
        <div className="container-cadastrar-departamento">
            {loading && <Loading />}
            <div className="container-geral-cadastro-departamento">
                <HeaderContainers texto="cadastro de departamento" />

                <div className="formulario-cadastrar-departamento">
                    <form>
                        <div className="inputs-principais-cadastro-departamento">
                            <InputPadrao
                                onChange={handleChange}
                                titulo={t("nome-departamento")}
                                obrigatorio={true}
                                name={"nome-departamento"}
                                className={"nome-departamento-cad"}
                                placeholder={t("place-holder-departamento")}
                                inputPara={"nomeDepartamento"}
                                icone={<MdBadge />}
                                comErro={!nomeDepartamentoValido}
                            />

                            <InputPadrao
                                onChange={handleChange}
                                className={"sigla-departamento-cad"}
                                titulo={t("sigla")}
                                obrigatorio={true}
                                name={"sigla-departamento"}
                                placeholder={t("place-holder-siglas-departamento")}
                                inputPara={"sigla"}
                                icone={<SiGlassdoor />}
                                comErro={!siglaValida}
                            />

                            <InputSelectPadrao
                                onChange={handleChange}
                                className={"situacao-cadastro-departamento-cad"}
                                titulo={t("situacao-cadastro")}
                                obrigatorio={true}
                                icone={<RiErrorWarningFill />}
                                name={"situacao-cadastro"}
                                placeholder={t("place-holder-sitCad")}
                                inputPara={"situacaoCadastro"}
                                options={situacoesCadastro}
                                comErro={!situacaoCadastroValida}
                            />
                        </div>

                        <div className="botoes-cadastro-departamento">
                            <BotaoPadrao
                                acaoDeClicar={handleCancelar}
                                texto={t("botao-cancelar")}
                                cancelar={true}
                            />
                            <BotaoPadrao
                                acaoDeClicar={clickBotaoConfirmar}
                                texto={mensagemBotaoConfirmar}
                                confirmar={true}
                                disabled={botaoDesabilitado}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default FormCadastroDepartamento;